var _rect, _rect2, _rect3, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlock1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 32,
    viewBox: "0 0 396 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 32,
    rx: 4,
    fill: "#F4F4F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    width: 150,
    height: 32,
    rx: 4,
    fill: "#F4F4F4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    width: 72,
    height: 32,
    rx: 4,
    fill: "#E2F2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.914 16L362.207 11.2928L360.793 12.7071L363.086 15H353V17H363.086L360.793 19.2928L362.207 20.7071L366.914 16ZM364 16.0858L364.086 16L364 15.9142V16.0858Z",
    fill: "#61B9FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 16,
    r: 3,
    fill: "#8F8B8F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 16,
    r: 3,
    fill: "#8F8B8F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 16,
    r: 3,
    fill: "#8F8B8F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 16,
    r: 3,
    fill: "#8F8B8F"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 16,
    r: 3,
    fill: "#8F8B8F"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 16,
    r: 3,
    fill: "#8F8B8F"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 16,
    r: 3,
    fill: "#8F8B8F"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 16,
    r: 3,
    fill: "#8F8B8F"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 16,
    r: 3,
    fill: "#8F8B8F"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 16,
    r: 3,
    fill: "#8F8B8F"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 16,
    r: 3,
    fill: "#8F8B8F"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 233,
    cy: 16,
    r: 3,
    fill: "#8F8B8F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlock1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/block1.c893ca63e8fcb27677e5348edd991834.svg";